var React = require('react');

function StarTiny (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"M7315.5 744.552L7309.783 736.252 7310.063 746.309 7300.533 742.937 7306.703 750.909 7297 753.752 7306.703 756.595 7300.533 764.568 7310.063 761.196 7309.783 771.252 7315.5 762.953 7321.217 771.252 7320.937 761.196 7330.467 764.568 7324.297 756.595 7334 753.752 7334 753.752 7324.297 750.909 7330.467 742.937 7320.937 746.309 7321.217 736.252z","transform":"translate(-7297.000000, -736.000000)"}))));
}

StarTiny.defaultProps = {"width":"37","height":"36","viewBox":"0 0 37 36"};

module.exports = StarTiny;

StarTiny.default = StarTiny;
